export enum RewardThresholdType {
    Percentage = 0,
    Points = 1,
}

export interface IUpdateRewardThresholdsRequest {
    goldThresholdValue: number;
    silverThresholdValue: number;
    bronzeThresholdValue: number;
    thresholdType: RewardThresholdType;
}
